export interface VideoItem {
  id: number;
  title: string;
  category: string;
  subcategory: string;
  coverImage: string;
  rating: number;
  year: number;
  region: string;
  episodes: string;
  description: string;
  actors: string[];
  director: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  tags: string[];
}

export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '长安十二时辰',
    category: 'dianshiju',
    subcategory: '古装剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20Dynasty%20warriors%20in%20armor%20holding%20swords%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20historical%20atmosphere%2C%20movie%20poster%20style%20with%20Chinese%20calligraphy%20text%20space&width=600&height=800&seq=mahua-dianshiju-01&orientation=portrait',
    rating: 8.9,
    year: 2024,
    region: '中国大陆',
    episodes: '48集全',
    description: '唐天宝三年，上元节的长安城暗流涌动。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安城。一部融合悬疑、动作、历史元素的高品质古装巨制，画面精良，剧情紧凑，演技在线。',
    actors: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    director: '曹盾',
    isHot: true,
    isNew: false,
    views: 12580000,
    tags: ['悬疑', '古装', '动作', '历史'],
  },
  {
    id: 2,
    title: '狂飙',
    category: 'dianshiju',
    subcategory: '刑侦剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20police%20officer%20in%20dark%20suit%20standing%20against%20city%20night%20background%2C%20noir%20cinematic%20lighting%2C%20intense%20expression%2C%20dark%20blue%20and%20amber%20color%20scheme%2C%20movie%20poster%20style%20with%20tense%20atmosphere&width=600&height=800&seq=mahua-dianshiju-02&orientation=portrait',
    rating: 9.5,
    year: 2023,
    region: '中国大陆',
    episodes: '39集全',
    description: '一部扫黑题材的电视剧，讲述了以一线刑警安欣为代表的正义力量，与黑恶势力进行的长达二十年的生死搏斗。通过群像叙事展现扫黑过程中的黑白较量与复杂人性。',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    isHot: true,
    isNew: false,
    views: 35800000,
    tags: ['刑侦', '扫黑', '悬疑', '剧情'],
  },
  {
    id: 3,
    title: '繁花',
    category: 'dianshiju',
    subcategory: '都市剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Shanghai%20nostalgic%20drama%20poster%20with%20elegant%20woman%20in%20cheongsam%20dress%20neon%20lights%201990s%20Bund%20background%2C%20warm%20retro%20color%20tones%2C%20cinematic%20portrait%20composition%2C%20glamorous%20aesthetic%2C%20film%20poster%20style&width=600&height=800&seq=mahua-dianshiju-03&orientation=portrait',
    rating: 8.7,
    year: 2024,
    region: '中国大陆',
    episodes: '30集全',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人都有故事。一部讲述上海传奇的年代剧，由王家卫执导，美学风格独特。',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    isHot: true,
    isNew: true,
    views: 22100000,
    tags: ['年代', '商战', '都市', '剧情'],
  },
  {
    id: 4,
    title: '流浪地球2',
    category: 'dianying',
    subcategory: '科幻片',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20in%20space%20suit%20floating%20near%20massive%20space%20station%20earth%20in%20background%2C%20epic%20cinematic%20lighting%2C%20cool%20metallic%20tones%20with%20warm%20sun%20glow%2C%20blockbuster%20film%20poster%20style&width=600&height=800&seq=mahua-dianying-01&orientation=portrait',
    rating: 8.3,
    year: 2023,
    region: '中国大陆',
    episodes: 'HD高清',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    director: '郭帆',
    isHot: false,
    isNew: false,
    views: 45100000,
    tags: ['科幻', '灾难', '冒险', '视觉特效'],
  },
  {
    id: 5,
    title: '满江红',
    category: 'dianying',
    subcategory: '悬疑片',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20with%20ancient%20Chinese%20courtyard%20at%20night%20lanterns%20hanging%20soldiers%20in%20Song%20Dynasty%20armor%2C%20mysterious%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20composition%2C%20film%20poster%20style&width=600&height=800&seq=mahua-dianying-02&orientation=portrait',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    episodes: 'HD高清',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    director: '张艺谋',
    isHot: true,
    isNew: false,
    views: 38900000,
    tags: ['悬疑', '喜剧', '古装', '剧情'],
  },
  {
    id: 6,
    title: '三体',
    category: 'dianshiju',
    subcategory: '科幻剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20three%20suns%20in%20alien%20sky%20mysterious%20radio%20telescope%20on%20earth%2C%20cosmic%20and%20technological%20vibe%2C%20deep%20space%20color%20palette%2C%20contemplative%20composition%2C%20drama%20poster%20style&width=600&height=800&seq=mahua-dianshiju-04&orientation=portrait',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    episodes: '30集全',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘组织"科学边界"，接触到一个名为"三体"的虚拟现实游戏。一场关于人类文明的宏大叙事徐徐展开。',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    isHot: false,
    isNew: false,
    views: 19800000,
    tags: ['科幻', '悬疑', '剧情', '文学改编'],
  },
  {
    id: 7,
    title: '你好，李焕英',
    category: 'dianying',
    subcategory: '喜剧片',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20heartwarming%20comedy%20movie%20poster%20with%20mother%20and%20daughter%20smiling%201980s%20retro%20China%20factory%20background%2C%20warm%20nostalgic%20color%20tones%2C%20joyful%20atmosphere%2C%20portrait%20composition%2C%20film%20poster%20style&width=600&height=800&seq=mahua-dianying-03&orientation=portrait',
    rating: 8.1,
    year: 2021,
    region: '中国大陆',
    episodes: 'HD高清',
    description: '2001年某一天，刚考上大学的贾晓玲经历了人生中的一次大起大落。一心想要成为母亲骄傲的她，竟意外回到了1981年，与年轻时的母亲李焕英相遇。',
    actors: ['贾玲', '张小斐', '沈腾', '陈赫'],
    director: '贾玲',
    isHot: false,
    isNew: false,
    views: 56200000,
    tags: ['喜剧', '亲情', '穿越', '感人'],
  },
  {
    id: 8,
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    subcategory: '真人秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20outdoors%20in%20nature%20green%20forest%20background%2C%20energetic%20and%20fun%20vibe%2C%20bright%20natural%20lighting%2C%20cheerful%20composition%2C%20entertainment%20poster%20style&width=600&height=800&seq=mahua-zongyi-01&orientation=portrait',
    rating: 7.6,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第8期',
    description: '《奔跑吧》系列最新一季，以生态文明为主题，兄弟团走进大自然，在绿水青山间展开趣味挑战。寓教于乐，笑点满满，展现人与自然和谐共生的美好画面。',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    director: '',
    isHot: true,
    isNew: true,
    views: 15800000,
    tags: ['户外', '竞技', '搞笑', '真人秀'],
  },
  {
    id: 9,
    title: '斗罗大陆',
    category: 'dongman',
    subcategory: '玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20young%20warrior%20holding%20glowing%20blue%20hammer%20weapon%20fantasy%20world%20background%20spirit%20rings%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20anime%20illustration%20style%2C%20epic%20composition&width=600&height=800&seq=mahua-dongman-01&orientation=portrait',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第263集',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志后却来到了另一个世界——斗罗大陆。在这里，他展开了全新的人生旅程，一步步走向巅峰。',
    actors: [],
    director: '',
    isHot: true,
    isNew: false,
    views: 89200000,
    tags: ['玄幻', '热血', '战斗', '成长'],
  },
  {
    id: 10,
    title: '乘风破浪的姐姐',
    category: 'zongyi',
    subcategory: '音乐竞演',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20reality%20show%20poster%20with%20group%20of%20elegant%20women%20in%20stunning%20stage%20costumes%20performing%20on%20glittering%20stage%2C%20glamorous%20spotlight%20lighting%2C%20confident%20expressions%2C%20entertainment%20poster%20style&width=600&height=800&seq=mahua-zongyi-02&orientation=portrait',
    rating: 7.9,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第10期',
    description: '30+姐姐们再次集结，突破自我，挑战无限可能。用舞台证明年龄只是数字，用实力诠释乘风破浪的精神。每一场公演都是一次视觉与听觉的盛宴。',
    actors: [],
    director: '',
    isHot: false,
    isNew: true,
    views: 21300000,
    tags: ['音乐', '竞演', '女性', '励志'],
  },
  {
    id: 11,
    title: '第二十条',
    category: 'dianying',
    subcategory: '剧情片',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20courtroom%20scene%20judge%20and%20lawyers%20debating%2C%20serious%20atmosphere%2C%20dramatic%20lighting%20from%20windows%2C%20warm%20amber%20and%20dark%20wood%20tones%2C%20film%20poster%20style&width=600&height=800&seq=mahua-dianying-04&orientation=portrait',
    rating: 8.4,
    year: 2024,
    region: '中国大陆',
    episodes: 'HD高清',
    description: '围绕《刑法》第二十条关于"正当防卫"的法条展开，通过几个普通人的故事，探讨法律与正义的边界。张艺谋导演的现实题材力作，引人深思。',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    director: '张艺谋',
    isHot: true,
    isNew: true,
    views: 28700000,
    tags: ['剧情', '法律', '现实', '社会'],
  },
  {
    id: 12,
    title: '完美世界',
    category: 'dongman',
    subcategory: '玄幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%20with%20handsome%20young%20cultivator%20in%20white%20robes%20floating%20above%20ancient%20Chinese%20fantasy%20landscape%2C%20glowing%20spiritual%20energy%2C%20ethereal%20atmosphere%2C%20elegant%20color%20scheme%2C%20anime%20illustration%20style&width=600&height=800&seq=mahua-dongman-02&orientation=portrait',
    rating: 8.6,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第185集',
    description: '少年石昊自幼被夺走至尊骨，流落石村。凭借坚韧不拔的意志和过人的天赋，一步步走上修行之路。天生至尊，当镇压世间一切敌！',
    actors: [],
    director: '',
    isHot: false,
    isNew: false,
    views: 67300000,
    tags: ['玄幻', '热血', '修仙', '战斗'],
  },
  {
    id: 13,
    title: '我是刑警',
    category: 'dianshiju',
    subcategory: '刑侦剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20police%20procedural%20drama%20poster%20with%20detective%20examining%20evidence%20in%20dark%20room%20spotlight%20on%20case%20files%2C%20tense%20realistic%20atmosphere%2C%20muted%20cold%20tones%2C%20cinematic%20composition%2C%20TV%20drama%20poster%20style&width=600&height=800&seq=mahua-dianshiju-05&orientation=portrait',
    rating: 8.3,
    year: 2024,
    region: '中国大陆',
    episodes: '38集全',
    description: '以真实案件为蓝本，聚焦基层刑警的日常工作。没有超级英雄，只有一群普通的警察，用专业和执着守护着城市的安宁。真实感人，紧张刺激。',
    actors: ['于和伟', '张嘉益', '丁勇岱', '白敬亭'],
    director: '惠楷栋',
    isHot: false,
    isNew: true,
    views: 16300000,
    tags: ['刑侦', '纪实', '剧情', '悬疑'],
  },
  {
    id: 14,
    title: '消失的她',
    category: 'dianying',
    subcategory: '悬疑片',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20thriller%20movie%20poster%20with%20woman%20silhouette%20disappearing%20into%20dark%20ocean%20waves%20tropical%20island%20at%20night%2C%20suspenseful%20atmosphere%2C%20deep%20blue%20and%20black%20color%20scheme%2C%20film%20noir%20style%2C%20cinematic%20poster&width=600&height=800&seq=mahua-dianying-05&orientation=portrait',
    rating: 7.5,
    year: 2023,
    region: '中国大陆',
    episodes: 'HD高清',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。当何非苦寻无果之时，一个陌生女人突然出现，声称自己就是他的妻子。真相一层层剥开，令人不寒而栗。',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    director: '陈思诚',
    isHot: false,
    isNew: false,
    views: 42500000,
    tags: ['悬疑', '犯罪', '反转', '心理'],
  },
  {
    id: 15,
    title: '向往的生活',
    category: 'zongyi',
    subcategory: '慢综艺',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%20with%20celebrities%20cooking%20and%20farming%20in%20beautiful%20countryside%20mushroom%20house%2C%20warm%20sunlight%20natural%20greenery%2C%20peaceful%20pastoral%20atmosphere%2C%20cozy%20composition%2C%20entertainment%20poster%20style&width=600&height=800&seq=mahua-zongyi-03&orientation=portrait',
    rating: 8.0,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第12期',
    description: '回归田园，自给自足。嘉宾们在蘑菇屋中过着简单而充实的生活，招待远道而来的朋友。一餐一饭间，是都市人向往的诗和远方。',
    actors: ['黄磊', '何炅', '张艺兴'],
    director: '',
    isHot: false,
    isNew: false,
    views: 30200000,
    tags: ['生活', '美食', '慢综艺', '治愈'],
  },
  {
    id: 16,
    title: '凡人修仙传',
    category: 'dongman',
    subcategory: '修仙',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20humble%20young%20man%20holding%20ancient%20sword%20ascending%20toward%20heavenly%20realm%2C%20misty%20mountains%20and%20celestial%20palace%20in%20background%2C%20mystical%20golden%20light%2C%20epic%20anime%20illustration%20style&width=600&height=800&seq=mahua-dongman-03&orientation=portrait',
    rating: 9.1,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至第72集',
    description: '一个普通的山村穷小子韩立，偶然之下跨入一个江湖小门派。虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙。一部经典的凡人流修仙动漫。',
    actors: [],
    director: '',
    isHot: true,
    isNew: false,
    views: 74500000,
    tags: ['修仙', '凡人流', '热血', '成长'],
  },
];

export const faqList = [
  {
    question: '麻花视频需要注册会员才能观看吗？',
    answer: '不需要！麻花视频所有内容完全免费，无需注册、无需登录、无需会员，打开即可享受高清流畅的观影体验。我们致力于为用户提供最便捷的观影服务。',
  },
  {
    question: '麻花视频支持哪些设备观看？',
    answer: '麻花视频支持全平台观看，包括电脑（Windows/Mac）、手机（iOS/Android）、平板以及智能电视。只要有网络，随时随地畅享精彩内容。',
  },
  {
    question: '为什么麻花视频可以免费观看？',
    answer: '麻花视频通过与多家内容提供商合作，采用广告支持的商业模式，让用户在观看少量广告的前提下，免费享受海量正版影视内容。我们始终坚持以用户为中心，不断优化观影体验。',
  },
  {
    question: '麻花视频的画质如何？有高清选项吗？',
    answer: '麻花视频提供从标清到超清多种画质选择，大部分内容支持1080P高清和4K超清画质。系统会根据您的网络状况智能推荐最佳画质，您也可以手动切换。',
  },
  {
    question: '遇到播放卡顿怎么办？',
    answer: '如遇播放卡顿，建议您：1）检查网络连接；2）尝试切换较低画质；3）清除浏览器缓存；4）更换其他浏览器。麻花视频采用先进的CDN加速技术，正常情况下播放流畅不缓冲。',
  },
];

export const statsData = [
  { label: '视频总量', value: '10万+', icon: 'ri-film-line' },
  { label: '日活用户', value: '500万+', icon: 'ri-user-line' },
  { label: '高清覆盖率', value: '99.8%', icon: 'ri-4k-line' },
  { label: '用户好评率', value: '98.5%', icon: 'ri-thumb-up-line' },
];